<template>
<transition name="fade">
    <div :class="[mode === 'bottom' ? 'video-watermark_bottom': 'video-watermark_center']"
         :style="{bottom: bottom + 'px', right: right() + 'px'}">
        <img :src="adaptPic('static/watermark_light_vertical.png')" :style="{width: scaledRatio}" alt=""/>
    </div>
</transition>
</template>

<script>
import {adaptPic, Video, Device} from "../../utils";

export default {
    name: "VideoVerticalWatermark",
    props: {
        width: Number,
        height: Number,
        mode: {
            type: String,
            default: 'bottom'  // 'bottom' 或者 'center'
        }
    },
    data() {
        return {
            scaledRatio: '28%',
            bottom: this.mode === 'bottom' ? 20: 0 // default d
        }
    },
    mounted() {
        if (Video.isLandscapeVideo(this.height, this.width)) {
            this.scaledRatio = '16%';
            if (this.mode === 'bottom') this.bottom = 20;
        }
    },

    methods: {

        adaptPic(url) {
            return adaptPic(url);
        },

        right() {
            if (Device.isPadSize()) {
                const videoWidth = Device.narrowedMaxWidth;
                return (Device.maxScreenWidth - videoWidth) / 2 + 20;
            }
            return 20;
        }
    }
}
</script>

<style scoped>

/* 右侧居中展示 */
.video-watermark_center {
    position: absolute;
    top: 40px; /* 让 video-watermark_center div 向下偏移 40px；与 bottom 等高使得悬浮 div 居中展示 */
    /* 让 video-watermark_center div 向上偏移 40px；关键属性，使得悬浮 div 不会遮挡声控按钮；注意不能使用 bottom 相对位移，
       不然不生效；猜测原因是 top|bottom 只能二选其一 */
    margin-bottom: 40px;
    right: 20px; /* 这是 iphone 下的偏移，但是 pad 不行，因此需要动态计算处理啊，详情参考 right 方法 */
    height: auto; /* 关键属性，如果要使得 top + margin-bottom 后悬浮 div 能够高度居中展示，height 必须设置为 auto */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    opacity: 0.65;
    border: 0 solid black;
}

/* 靠右下方展示 */
.video-watermark_bottom {
    position: absolute;
    /* bottom: 60px; */ /* 动态设置，如果原始尺寸高度小于 .. 使用 bottom 20px */
    right: 0;
    opacity: 0.65;
}


/* 定义 transition fade 动效 */

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/VideoVerticalWatermark.vue